import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

/**
 * 獲取當前登入用戶的信息
 * @returns {Object} 用戶信息對象
 * @returns {string|null} token - JWT token
 * @returns {number|null} id - 用戶 ID
 * @returns {string|null} name - 用戶名稱
 * @returns {number|null} role - 用戶角色（從 JWT 解析）
 * @returns {number|null} companyId - 用戶所屬公司（從 JWT 解析）
 * @returns {boolean} isLoggedIn - 是否已登入
 */
export const useUser = () => {
    const token = Cookies.get('employeeToken');

    let id = null;
    let name = null;
    let role = null;
    let email = null;
    let phone = null;
    let companyId = null;

    // 從 JWT 解析敏感信息
    if (token) {
        try {
            const decoded = jwtDecode(token);
            id = decoded.id || null;
            name = decoded.name || null;
            role = decoded.role || null;
            email = decoded.email || null;
            phone = decoded.phone || null;
            companyId = decoded.companyId || null;
        } catch (error) {
            console.error('Failed to decode JWT:', error);
        }
    }

    return {
        token: token || null,
        id: id ? parseInt(id) : null,
        name: name || null,
        email: email || null,
        phone: phone || null,
        role: role ? parseInt(role) : null,
        companyId: companyId ? parseInt(companyId) : null,
        isLoggedIn: !!token
    };
};

/**
 * 保存用戶信息到 Cookie
 * @param {Object} userData - 用戶數據
 * @param {string} userData.token - JWT token
 * @param {number} userData.id - 用戶 ID
 * @param {string} userData.name - 用戶名稱
 * @param {number} userData.role - 用戶角色
 */
export const saveUserToCookie = (userData) => {
    const { token, id, name, role, email, phone, companyId } = userData;

    if (token) Cookies.set('employeeToken', token, { expires: 7 });
    if (id) Cookies.set('employeeId', id, { expires: 7 });
    if (name) Cookies.set('employeeName', name, { expires: 7 });
    if (role) Cookies.set('employeeRole', role, { expires: 7 });
    if (email) Cookies.set('employeeEmail', email, { expires: 7 });
    if (phone) Cookies.set('employeePhone', phone, { expires: 7 });
    if (companyId) Cookies.set('employeeCompanyId', companyId, { expires: 7 });
};

/**
 * 清除用戶信息從 Cookie
 */
export const clearUserFromCookie = () => {
    Cookies.remove('employeeToken');
    Cookies.remove('employeeId');
    Cookies.remove('employeeName');
    Cookies.remove('employeeRole');
    Cookies.remove('employeeEmail');
    Cookies.remove('employeePhone');
    Cookies.remove('employeeCompanyId');
};
